import { ProTagSelect } from '../../components/ProTagSelect';
import {
  FormCard,
  FormDescriptions,
  FormItemBaseEnum,
  FormItemRecommenderInfo,
  FormModule,
} from '@purchase/supplier';
import React from 'react';
import { ProTextWithCopy } from '../../components/ProTextWithCopy';
import { ProCustomFieldDate } from '../../components/ProCustomFieldDate';

// 经营信息
const BusinessInformation = (props: {
  namePath?: string[];
  mode?: 'card' | 'module';
  isExternal?: boolean;
  formDetail?: any;
}) => {
  const { namePath = [], mode = 'card', isExternal = false } = props;
  const Wrapper = mode === 'card' ? FormCard : FormModule;

  return (
    <Wrapper title="经营信息" proCardProps={{ expandable: true }}>
      <FormDescriptions columns={2} labelStyle={{ width: 180 }} margin={false}>
        <ProTagSelect
          label="服务类型"
          name={[
            ...namePath,
            'extendAttributeInfo',
            'serviceInformation',
            'serviceType',
          ]}
        />
        {!isExternal && (
          <ProTextWithCopy
            label="服务类型编号"
            name={[...namePath, 'externalVendorId']}
          />
        )}
        {!isExternal && (
          <ProTagSelect
            label="标签"
            name={[...namePath, 'extendAttributeInfo', 'businessTag']}
          />
        )}
        {!isExternal && (
          <FormItemBaseEnum
            label="供应商等级"
            name={[...namePath, 'vendorGradeInfo', 'vendorGrade']}
          />
        )}
        {!isExternal && (
          <ProCustomFieldDate
            label="等级生效日期"
            name={[...namePath, 'vendorGradeInfo', 'gradePeriodAt']}
          />
        )}
        {!isExternal && (
          <ProCustomFieldDate
            label="有效日期"
            name={[...namePath, 'vendorGradeInfo', 'gradeEffectiveAt']}
          />
        )}
        <FormItemBaseEnum
          label="服务覆盖区域"
          name={[
            ...namePath,
            'extendAttributeInfo',
            'serviceInformation',
            'serviceArea',
          ]}
        />
        <FormItemRecommenderInfo
          label="推荐人姓名"
          name={[...namePath, 'vendorRecommenderInfo']}
        />
      </FormDescriptions>
    </Wrapper>
  );
};

export default BusinessInformation;
